import { render, staticRenderFns } from "./TokenReset.vue?vue&type=template&id=9772e422&"
import script from "./TokenReset.vue?vue&type=script&lang=js&"
export * from "./TokenReset.vue?vue&type=script&lang=js&"
import style0 from "./TokenReset.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports